import { useSelector } from "react-redux";
import {
  FooterPlayerInfoWithActions,
  FooterPlayer as StyledFooterPlayer,
} from "./styled";
import { AudioInfoWrapper } from "./AudioInfoWrapper";
import { FooterPlayerRange } from "../FooterPlayerRange/FooterPlayerRange";
import { FooterPlayerSecondaryActions } from "./FooterPlayerSecondaryActions";
import { FooterPlayerMainActions } from "./FooterPlayerMainActions";
import { useOpenDrawerTrack } from "../../hooks/useOpenDrawerTrack";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { useFooterPlayer } from "../../contexts/FooterPlayerContext";

export const FooterPlayer = () => {
  const currentEntity = useSelector((state) => !!state.player.currentEntity);

  const isMobile = useMediaQuery("(max-width: 981px)");
  const openDrawer = useOpenDrawerTrack();
  const { footerPlayerRef } = useFooterPlayer();

  if (!currentEntity) return null;

  return (
    <StyledFooterPlayer ref={footerPlayerRef}>
      <FooterPlayerRange />
      <FooterPlayerInfoWithActions
        {...(isMobile && { onPointerUp: openDrawer })}
      >
        <AudioInfoWrapper />
        <FooterPlayerMainActions />
      </FooterPlayerInfoWithActions>
      <FooterPlayerSecondaryActions />
    </StyledFooterPlayer>
  );
};
